import withUserProfileData from './withUserProfileData';

export default withUserProfileData;
